// settings/power_plnats#indexの並び替えのライブラリ
import $ from "jquery";
import "tablesorter";

$(function() {
  $('#fav-table').tablesorter();
});